(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gl-journey"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGlJourney(container) {
    var track = container.querySelector('.gl-journey__steps');
    if (!track) return;

    var steps = Array.from(track.querySelectorAll('.gl-journey__step'));
    var dots = Array.from(container.querySelectorAll('.gl-journey__dot'));

    if (!steps.length) return;

    function setActiveDot(idx) {
      dots.forEach(function (d, i) {
        d.classList.toggle('gl-journey__dot--active', i === idx);
      });
    }

    if (dots.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = parseInt(entry.target.dataset.stepIndex, 10);
              if (!isNaN(idx)) setActiveDot(idx);
            }
          });
        },
        { root: track, threshold: 0.55 }
      );
      steps.forEach(function (step) { observer.observe(step); });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var step = steps[i];
        if (!step) return;
        var offset = step.offsetLeft - (track.clientWidth - step.clientWidth) / 2;
        track.scrollTo({ left: offset, behavior: 'smooth' });
      });
    });

  }

  function initAll() {
    document.querySelectorAll('.gl-journey').forEach(initGlJourney);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target.querySelector('.gl-journey');
    if (container) initGlJourney(container);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
